import {
  AfterViewInit,
  Component,
  Input,
  NgZone
} from "@angular/core";
import { MapImageOverlay, ScoutTask } from "../../core/models";
import { ScoutTaskDoc } from "../../core/schema/scout-task-schema";
import {
  BuildingService,
  ScoutPointPhotoService,
  ScoutTaskService
} from "../../core/services";
import { KmlViewerComponent } from "../../shared/mapping/kml/kml-viewer/kml-viewer.component";
import { ScoutKmlBuilder } from "./scout-kml-builder";

export type Scout3dModalInitialState = {
  scoutTaskDoc: ScoutTask;
  pathIds?: string[];
};

@Component({
  selector: "fes-scout-kml-viewer",
  templateUrl: "../../shared/mapping/kml/kml-viewer/kml-viewer.component.html",
  styleUrls: ["../../shared/mapping/kml/kml-viewer/kml-viewer.component.scss"],
})
export class ScoutKmlViewerComponent extends KmlViewerComponent implements AfterViewInit {
  @Input() scoutTaskDoc: ScoutTaskDoc;

  constructor(
    ngZone: NgZone,
    public scoutTaskService: ScoutTaskService,
    buildingService: BuildingService,
    photoService: ScoutPointPhotoService,
  ) {
    super(ngZone, buildingService, photoService);
  }

  ngAfterViewInit(): void {
    this.init();
  }

  override async init() {
    try {
      const scoutPaths = this.scoutTaskDoc.scoutPaths;
      scoutPaths.forEach((scoutPath) =>
        this.scoutTaskService.updateScoutPathContext(
          scoutPath,
          []
        )
      );
      const overlayMap: Record<string, MapImageOverlay | undefined> = {};
      scoutPaths?.forEach((scoutPath) => {
        if (scoutPath?.overlay) {
          overlayMap[scoutPath.id] = scoutPath.overlay;
        }
      });
      this.overlaysByPathId = overlayMap;
      this.paths = scoutPaths?.map(scoutPath=>ScoutKmlBuilder.scoutPathAsKmlBuilderPath({scoutPath,buildingId:this.scoutTaskDoc.buildingId}))||[];
      await super.init();
    } catch (error: any) {
      console.error(error);
    }
  }
}
